import { useEffect, useState, useMemo } from "react";
import io from "socket.io-client";

import "../assets/css/common.css";
import "../assets/css/Home.css";
import Cards from "../components/Card";
import Map from "../assets/img/map.png";

import { Col, Container, Row } from "react-bootstrap";

// SOCKET (ADMIN LISTENER)
const socket = io("https://api.agrifresh.ae", {
	timeout: 20000,
});

//  AUTO FLAG FUNCTION (WORKS FOR ALL COUNTRIES)
function countryCodeToFlag(code) {
	if (!code) return "🏳️";
	return code
		.toUpperCase()
		.replace(/./g, (char) =>
			String.fromCodePoint(127397 + char.charCodeAt())
		);
}

function Home() {
	const [visitors, setVisitors] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		socket.on("liveVisitors", (data) => {
			setVisitors(Array.isArray(data) ? data : []);
			setLoading(false);
		});

		return () => {
			socket.off("liveVisitors");
		};
	}, []);

	//  COUNTRY + STATE + CITY WISE ONLINE COUNT
	const locationStats = useMemo(() => {
		const map = {};

		visitors.forEach((v) => {
			const country = v.country || "Unknown";
			const countryCode = v.countryCode || "";
			const state = v.state || "Unknown";
			const city = v.city || "Unknown";

			const key = `${country}-${state}-${city}`;

			if (!map[key]) {
				map[key] = {
					country,
					countryCode,
					state,
					city,
					online: 0,
				};
			}

			map[key].online += 1;
		});

		return Object.values(map).sort((a, b) => b.online - a.online);
	}, [visitors]);

	return (
		<Container className="modeva-container-body navigate">
			<Row>
				<Col lg="12">
					<div className="markup-home bg-white p-4 shadow-sm rounded-3">
						<Cards />
						<div className="visit-country">
							<div className="container">
								<div className="row">
									{/* TABLE */}
									<div className="col-12 col-md-6">
										<h3>Live Visitors</h3>
										<table className="table table-striped table-dark table-hover">
											<thead>
												<tr>
													<th>No</th>
													<th>Country</th>
													<th>State</th>
													<th>City</th>
													<th>Online</th>
												</tr>
											</thead>
											<tbody>

												{loading && (
													<tr>
														<td colSpan="5" className="text-center">
															Connecting to live server...
														</td>
													</tr>
												)}

												{!loading && locationStats.length > 0 &&
													locationStats.map((item, i) => (
														<tr key={i}>
															<td>{i + 1}</td>
															<td>
																{countryCodeToFlag(item.countryCode)}{" "}
																{item.country}
															</td>
															<td>{item.state}</td>
															<td>{item.city}</td>
															<td>{item.online}</td>
														</tr>
													))
												}

												{!loading && locationStats.length === 0 && (
													<tr>
														<td colSpan="5" className="text-center">
															No live visitors
														</td>
													</tr>
												)}

											</tbody>
										</table>

									</div>

								</div>
							</div>
						</div>

					</div>
				</Col>
			</Row>
		</Container>
	);
}

export default Home;
